<div class="h-screen">
  <div class="bg-(--color-bg-secondary)">
    @if (showNavbar()) {
      <div class="fixed top-0 left-0 w-full z-10">
        <app-navbar />
      </div>
    }
    <div class="bg-(--color-bg-secondary)" [class]="showNavbar() ? 'pt-21.75 h-screen' : 'h-screen'">
      <router-outlet />
    </div>
  </div>
  <app-toast />
</div>
